module.exports = __webpack_public_path__ + "static/preview-sg-1ba2551a400b77e0827c421c02465240.jpg";